import type { IconSvgObject } from './types';

const HashIcon: IconSvgObject = [
  ["path", { d: "M10 3L8 21M16 3L14 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 9H20M4 15H20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default HashIcon;
